module.exports = __webpack_public_path__ + "static/media/pxu-logo.6b28af33.svg";